import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.linkContact.1";
import { getInitialValues } from "./schema.linkContact.utils";

// eslint-disable-next-line import/no-default-export
export default () => {
  const initialValues = getInitialValues();
  return [
    {
      schema: getSchema1(initialValues),
      uiSchema: uiSchema1(),
    },
  ];
};
